import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getRandomHash } from '@/checkout-instore-legacy/utils/ErrorUtils'

class ErrorBoundary extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      error: null,
      info: null,
      errorId: getRandomHash(),
    }
  }

  componentDidCatch(error, info) {
    const { onError } = this.props

    const { errorId } = this.state

    if (typeof onError === 'function') {
      try {
        onError(error, info ? info.componentStack : '', errorId)
      } catch (error) {
        console.error('ErrorBoundary error', error)
      }
    }

    this.setState({ error, info })
  }

  render() {
    const { children, FallbackComponent } = this.props
    const { error, info, errorId } = this.state

    if (error !== null) {
      return (
        <FallbackComponent
          componentStack={info ? info.componentStack : ''}
          error={error}
          errorId={errorId}
        />
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  FallbackComponent: PropTypes.any.isRequired,
  onError: PropTypes.func,
}

export default ErrorBoundary
